export class ChatSessionPreferenceService {
  constructor() {
    this.csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  }

  updatePreference() {
    fetch('/chat_session/preferences', {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken
      },
      body: JSON.stringify({ chat_session_preference: { notify: false } })
    });
  }
}
